import './ProbabilityMarket.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux';
import FilterThiTruong from '../../../common/FilterThiTruong';
import LabelFooter from 'components/common/Chart/LabelFooter';
import { options } from './ProbabilityMarketConfig';
import useMarket from 'hook/useMarket';
import { useEffect, useState } from 'react';

export default function ProbabilityMarket() {
  const [filter, setFilter] = useState({ category: 'WHOLE_MARKET' })
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)
  const MarketStore = useSelector((state: any) => state?.MarketStore)
  const { fetchTransprobability, filterTransprobability } = useMarket();
  
  useEffect(() => {
    fetchTransprobability(filter);
  }, [filter])

  let fontSizeLabel = '14px'
  let windownHeight = 573;
  if (CommnonStore?.innerWidthScreen < 700) {
    windownHeight = 200;
    fontSizeLabel = '10px'
  }

  return (
    <>
      <div className='rictbyahte'>
        <FilterThiTruong defaultData={filter.category}
          setSelectOption={(value: any) => setFilter({ ...filter, category: value })}
          data={[
            { name: 'Toàn thị trường', value: 'WHOLE_MARKET' },
            { name: 'Vốn hoá vừa', value: 'LARGE_CAP' },
            { name: 'Vốn hoá nhỏ', value: 'SMALL_CAP' },
          ]} />
        <div className='lmxpdicgvn'>Đánh giá xác suất đầu tư: <span className='nnabtnhpsf'>{MarketStore?.marketTransprobability?.assessment}</span></div>
        <div className='zbkhjuabne'>
          <div className='jueorqezef'>
            <HighchartsReact
              highcharts={Highcharts}
              options={options(filterTransprobability(MarketStore?.marketTransprobability?.dscMrkTransactionProbability), windownHeight, fontSizeLabel)}
            />

            <LabelFooter data={[
              { name: 'Tín hiệu mua', color: '#22AB24' },
              { name: 'Tín hiệu bán', color: '#F7931A' },
            ]} />
          </div>
        </div>
      </div>
    </>
  )
}